/**
 * Chat Connection Factory
 * 
 * Creates SignalR chat connection for .NET backend
 */

import { IChatConnection, ChatBackendType } from './IChatConnection';
import { SignalRChatConnection } from './SignalRChatConnection';

export class ChatConnectionFactory {
  /**
   * Create a SignalR chat connection for .NET backend
   * 
   * @param type - Backend type ('dotnet')
   * @param url - Backend URL
   * @param token - Optional authentication token
   * @returns Chat connection instance
   */
  create(type: ChatBackendType, url: string, token?: string): IChatConnection {
    // Always use SignalR for .NET backend
    return new SignalRChatConnection(url, token);
  }
}

// Singleton instance
export const chatConnectionFactory = new ChatConnectionFactory();
